// AI Chat Context Types
export const CONTEXT_TYPE_CUSTOMER = 'customer';
export const CONTEXT_TYPE_INVOICE = 'invoice';
export const CONTEXT_TYPE_ORDER = 'order';
export const CONTEXT_TYPE_PROPOSAL = 'proposal';
export const CONTEXT_TYPE_ROUTE = 'route';
export const CONTEXT_TYPE_AR_RECONCILIATION = 'ar_reconciliation';
export const CONTEXT_TYPE_AR_MONTH_END = 'ar_month_end';
export const CONTEXT_TYPE_AGING_REPORT = 'aging_report';

export const ALL_CONTEXT_TYPES = [
    CONTEXT_TYPE_CUSTOMER,
    CONTEXT_TYPE_INVOICE,
    CONTEXT_TYPE_ORDER,
    CONTEXT_TYPE_PROPOSAL,
    CONTEXT_TYPE_ROUTE,
    CONTEXT_TYPE_AR_RECONCILIATION,
    CONTEXT_TYPE_AR_MONTH_END,
    CONTEXT_TYPE_AGING_REPORT,
];
